<template>
    <div class="sidebar-pinned">
      <Navbar />
  
      <main class="admin-main">
        <!--site header begins-->
        <section class="admin-content">
          <div class="container">
           
  
            <div class="col-md-12" style="margin-top: 20px">
              <EncounterbyLGA />
            </div>
  
            <div class="col-md-12" style="margin-top: 20px">
              <EncounterbyDiagnosis />
            </div>
  
            <ClientDataDashboard />
          </div>
          <Footer />
        </section>
      </main>
    </div>
  </template>
  
  <script>
  import Navbar from "@/views/Navbar.vue";
  import Footer from "@/views/Footer.vue";
  import EncounterbyDiagnosis from "@/views/shis/component/EncounterbyDiagnosis.vue";
  import EncounterbyLGA from "@/views/shis/component/EncounterbyLGA.vue";
  
  export default {
    components: {
      Navbar,
      Footer, EncounterbyDiagnosis, EncounterbyLGA
    },
  
    data() {
      return {
        user: null,
        formal_S: true,
        informal_S: false,
        mydata: "",
        auth_user: "",
        providers: "",
        clients: "",
        trial_date: "01/01/2023",
        total_clients: "",
        claims: "",
        offlineclients: [],
        employees: "",
        plans: "",
        tpas: "",
        buttoncolor: {
          informal: "btn btn-default",
          formal: "btn btn-info",
        },
      };
    },
    beforeMount() {
      this.axios
        .get(`/api/v1/auth/user`)
        .then((response) => {
          this.auth_user = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    computed: {
      //
    },
  
    methods: {
      showFormal() {
        this.formal_S = true;
        this.informal_S = false;
        this.buttoncolor.formal = "btn btn-info";
        this.buttoncolor.informal = "btn btn-default";
      },
      showInformal() {
        this.formal_S = false;
        this.informal_S = true;
        this.buttoncolor.informal = "btn btn-info";
        this.buttoncolor.formal = "btn btn-default";
      },
  
  
  
     
    },
    created() {
    },
  };
  </script>
  <style lang="css" scoped>
  
  </style>
  